import { useState, Fragment, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from 'axios';
import './App.css';
import LoginForm from './components/loginForm/LoginForm'
import Topbar from './components/topbar/Topbar'
import Sidebar from './components/sidebar/Sidebar'
import Dashboard from './components/dashboard/Dashboard';
import Sidemenu from './components/sidemenu/Sidemenu';
import OverUsers from './components/users/overview/OverUsers'
import AddUsers from './components/users/add/AddUsers'
import UpdateUsers from './components/users/update/UpdateUsers';
import OverDP from './components/donationPrograms/overview/OverDP';
import AddDP from './components/donationPrograms/add/AddDP';
import UpdateDP from './components/donationPrograms/update/UpdateDP';
import OverBR from './components/bloodRequests/overview/OverBR';
import AddBR from './components/bloodRequests/add/AddBR';
import UpdateBR from './components/bloodRequests/update/UpdateBR';
import OverBB from './components/bloodBanks/overview/OverBB';
import AddBB from './components/bloodBanks/add/AddBB';
import UpdateBB from './components/bloodBanks/update/UpdateBB';

function App() {
  const [loginStatus, setLoginStatus] = useState('')
  const [error, setError] = useState('')

  const logoutServer = () => {
    let formData = new FormData();
    formData.append('status', 'false')

    axios({
      method: 'post',
      url: 'https://blood147.000webhostapp.com/admin_panel/updateLogin.php/?id=1',
      data: formData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
      //handle success
      console.log(response);
    })
    .catch(function (response) {
        //handle error
        console.log(response)
      console.error(this.props.url, error.toString())
    });
  }

  useEffect(() => {
    window.onbeforeunload = (event) => {
      const e = event || window.event;
      // Cancel the event
      e.preventDefault();
      if (e) {
        e.returnValue = ''; // Legacy method for cross browser support
        logoutServer()
      }
      return ''; // Legacy method for cross browser support
    };
  }, [])
  
  useEffect(() => {
    fetch('https://blood147.000webhostapp.com/admin_panel/readLogin.php')
    .then((response) => response.json())
    .then((info) => {
      info.map((log) => {
        if (log.status == 'true') {
          setLoginStatus('true')
        }
        if (log.status == 'false') {
          setLoginStatus('false')
        }
      })
    })
    .catch((error) => console.log(error))
  }, []);


  const Login = details => {
    if (details.name == 'admin' && details.password == 'admin') {
      updateStatusTrue()
    } else {
      setError('Enter admin on both.')
    }
  }

  const updateStatusTrue = () => {
    let formData = new FormData();
    formData.append('status', 'true')

    axios({
      method: 'post',
      url: 'https://blood147.000webhostapp.com/admin_panel/updateLogin.php/?id=1',
      data: formData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
      if(response.data == 'success'){
        setLoginStatus('true')
      }
      else{
        alert('Server issue!!\nPlease try again later!!')
      }
    })
    .catch(function (response) {
        //handle error
        console.log(response)
    });
  }

  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      {(loginStatus == 'true') && (
        <Router>
        <Fragment>
          <Topbar toggle={toggle} setLoginStatus={setLoginStatus}/>
          <Sidemenu isOpen={isOpen} toggle={toggle} setLoginStatus={setLoginStatus} />
          <div className='container'>
          <span>
            <Sidebar />
            <Routes>
              <Route exact path='/' element={<Dashboard/>}/>
              <Route exact path='/overUsers' element={<OverUsers/>}/>
              <Route exact path='/addUsers' element={<AddUsers/>}/>
              <Route exact path='/updateUsers/:id' element={<UpdateUsers/>}/>
              <Route exact path='/overBB' element={<OverBB/>}/>
              <Route exact path='/addBB' element={<AddBB/>}/>
              <Route exact path='/updateBB/:id' element={<UpdateBB/>}/>
              <Route exact path='/overBR' element={<OverBR/>}/>
              <Route exact path='/addBR' element={<AddBR/>}/>
              <Route exact path='/updateBR/:id' element={<UpdateBR/>}/>
              <Route exact path='/overDP' element={<OverDP/>}/>
              <Route exact path='/addDP' element={<AddDP/>}/>
              <Route exact path='/updateDP/:id' element={<UpdateDP/>}/>
            </Routes>
          </span>
          </div>
        </Fragment>
      </Router> 
      )}
      
      {(loginStatus == 'false') && (
        <LoginForm Login={Login} error={error}/>
      )}
    </>
  );
}

export default App;
